import React from 'react';

const LineupTitle = () => {
  return (
    <div
      className="
        w-full
        max-w-md
        mx-auto
        py-4
        px-8
        flex
        items-center
        justify-center
        bg-[linear-gradient(to_right,rgba(255,255,255,0)_0%,rgba(27,42,141,0.8)_13%,rgba(27,42,141,1)_50%,rgba(27,42,141,0.8)_85%,rgba(255,255,255,0)_100%)]
      "
    >
      <h2 className="text-white text-4xl font-bold tracking-widest text-center">
        DÀN LINE UP
      </h2>
    </div>
  );
};

export default LineupTitle;